var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"mb-6",class:_vm.background},[_c('BaseGridLayout',{attrs:{"size":_vm.size}},[_c('div',{staticClass:"col-span-full flex flex-col"},[_c(_vm.componentTag,_vm._b({tag:"component",staticClass:"!w-full",class:[
          _vm.sizeClasses,
          { 'text-white' : _vm.background === 'bg-darkgreen' },
        ],attrs:{"id":_vm.anchorName}},'component',_vm.teaser,false))],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }